import Lottie from "lottie-react";

import Aos from "aos";
import { useEffect } from "react";
import "aos/dist/aos.css";

const Card = ({ index, title, icon }) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div
      data-aos={index === 0 || index === 1 ? "slide-right" : "slide-left"}
      className="w-[280px] group flex flex-col items-center p-6 border bg-gray-50 h-[380px] cursor-pointer rounded-lg "
    >
      <Lottie className="w-[200px] group-hover:scale-125 transition ease-in-out h-[200px]" animationData={icon} />
      <div>
        <h2 className="font-bold text-lg">{title}</h2>
        <p className="mt-2">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Suscipit
          delectus omnis repellendus odio! Est, vero?
        </p>
      </div>
    </div>
  );
};
export default Card;
